import { useEffect, useRef, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import './hex-color-presentation.css';

export function groupedHex(value: string) {
  return /^#[0-9a-f]{6}$/i.test(value) ? '#' + value.slice(1).toUpperCase().match(/../g)!.join(' ') : '';
}

/** Decorate the shared native field without changing its value or event handlers. */
export function HexColorPresentation({ value, fieldLabel, className = '', children }: {
  value: string; fieldLabel: string; className?: string; children: ReactNode;
}) {
  const root = useRef<HTMLDivElement>(null);
  const [host, setHost] = useState<HTMLElement | null>(null);
  const [display, setDisplay] = useState(() => groupedHex(value));
  useEffect(() => {
    const input = [...(root.current?.querySelectorAll<HTMLInputElement>('input[type=text]') ?? [])]
      .find(input => input.getAttribute('aria-label') === fieldLabel);
    setHost(input?.parentElement ?? null);
  }, [fieldLabel]);
  useEffect(() => { setDisplay(groupedHex(value)); }, [value]);
  const matches = (target: EventTarget): target is HTMLInputElement => target instanceof HTMLInputElement && target.getAttribute('aria-label') === fieldLabel;
  return <div className={`hex-color-presentation ${className}`} ref={root} onInputCapture={event => {
    const input = event.target;
    if (matches(input)) setDisplay(groupedHex(input.value));
  }} onBlurCapture={event => { if (matches(event.target)) setDisplay(groupedHex(value)); }}>
    {children}
    {host && createPortal(<span className="hex-color-readout" aria-hidden="true">{display}</span>, host)}
  </div>;
}
